module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/ae-23c174705b39d649ba4341c8f1c83aac.svg";